import { Address } from "./address";
import { Employment } from "./employment";
import { ReferenceContact } from "./reference-contact";
import { MilitaryDetail } from "./military-detail";
import { IncomeAssertVerification } from "./income-assert-verification";
import { Counselling } from "./counselling";
import { Assets } from "./assets";
import { Liability } from "./liabilities";
import { REO } from "./reo";
import { Declaration } from "./declaration";
import {Demographics} from './demographics';
import {DemographicGovtQuestions} from './demographic-govt-questions';
import {EmploymentIncome} from './employment-income';
import {CurrentIncomeItem} from "@data/schema/loan-appication/current-income-item";

export class Borrower {
  id: string;
  // general
  sSSN: string="";
  sDateOfBirth: Date;
  sCitizenShipType: number;
  sCitizenShipDesc ="";
  sMaritalStatusType : number = 0;
  sMaritalStatusDesc = "";
  sFirstName: string="";
  sLastName: string="";
  sMiddleName: string="";
  sSuffixName: string="";
  sDomesticRelationShipFlag: boolean;
  sDomesticRelationShipType: number;
  sDomesticRelationShipTypeDesc = "";
  sDomesticRelationShipState: string;
  sDomesticRelationShipStateDesc ="";
  sDependentAgesYear: string;
  sDependentCount : number;
  sDependentFlag: boolean;
  sLanguagePrefereceType: number;
  sLanguagePrefereceTypeDesc: string;
  sApplicantType: number;
  sApplicantTypeDesc : string = "";
  // contacts
  sBorrEmail: string="";
  sBorrMobilePhone: string="";
  sBorrWorkPhone: string;
  sBorrHomePhone: string;
  sBorrTollFreePhone: string;
  sBorrFax: string;
  // credit score
  sBorrExpScore: number;
  sBorrTransScore: number;
  sBorrEquifaxScore: number;
  sCoBorrowerId : string;
  // address
  sCurrentAddress: Address = new Address();
  sPreviousAddress: Address[] = [];
  sMailingAddress: Address = new Address();
  sResidencyType: number;
  sResidencyTypeDesc = "";
  sResidencyDuration: number;
  sMailingAddressSameAsCurrentAddressFlag: boolean;
  //additional
  sAKANames: string;
  sPOASigner: string;
  sPOASignerTitle: string;
  sPOASignerEmail: string;
  sCommunityPropertyStateFlag: boolean;
  // employment
  sCurrentEmployments: Employment[] = [];
  sPreviousEmployments: Employment[] = [];
  //nearest living relatives
  sNearestLivingRelative: ReferenceContact = new ReferenceContact();
  //military
  sMilitaryDetail: MilitaryDetail = new MilitaryDetail();
  //verification
  sIncomeAssetVerification: IncomeAssertVerification[] = [];

  //counselling
  sCounselling: Counselling = new Counselling();

  //assets and liabilities
  sAssets: Assets[] = [];
  sLiabilities: Liability[] = [];
  //Real Estate Owned
  sREO: REO[] =[];
  //declaration

  sDeclaration: Declaration = new Declaration(1,false);
  sDemograhics : DemographicGovtQuestions = new DemographicGovtQuestions(1,false);

  //income
  sCurrentIncomeItems : CurrentIncomeItem[] =[];
  sCurrentNonIncomeItems : CurrentIncomeItem[] =[];
  sCurrentEmploymentIncomeTypeDummy : number =0;


  uiShow: boolean;
  uiArrow: string;
  uiExpanderText = "Expand";


}
